<template>
  <div id="app">
    <!--顶部导航-->
    <header-com
      ref="header"
      @getList="getListHandle"
      v-if="list.indexOf(name) >= 0 && headerShow"
      :key="name"
    ></header-com>
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :keyword="keyword"
        @showLoginHandle="showLoginHandle"
        @showLogin="showLogin"
        @showLoginUp="showLoginUp"
        @header="header"
      ></router-view>
    </keep-alive>
    <router-view
        v-if="!$route.meta.keepAlive"
        :keyword="keyword"
        @showLoginHandle="showLoginHandle"
        @showLogin="showLogin"
        @showLoginUp="showLoginUp"
        @header="header"
      ></router-view>
  </div>
</template>

<script>
import HeaderCom from '../src/pages/components/floatHeader.vue'
import { postAction, getAction } from '@/api/manage.js'
import Vue from 'vue'

export default {
  components: { HeaderCom },
  name: 'App',
  data() {
    if (
      !this.$ls.get('token') ||
      this.$ls.get('token') == 'null' ||
      this.$ls.get('token') == 'undefined'
    ) {
      this.$ls.set('token', this.getUrlVars()['token'])
    }
    if (
      !this.$ls.get('realname') ||
      this.$ls.get('realname') == 'null' ||
      this.$ls.get('realname') == 'undefined'
    ) {
      this.$ls.set('realname', this.getUrlVars()['realname'])
    }
    if (this.getUrlVars()['dcode']) {
      this.$ls.remove('token')
    }
    // 初始化数量
    localStorage.setItem('num', 0)

    let list = []
    this.$router.options.routes.filter((item) => {
      if (item.name != 'google-register' && item.name != 'trustpilot' && item.name != 'store-info' && item.name != 'my-profile' && item.name != 'vi local' && item.name != 'vilocal-v3' && item.name != 'help' && item.name != 'Wholesale' && item.name != 'creditPayment' && item.name != 'credit-payment' && item.name != 'apply' && item.name != 'profile' && item.name != 'verify-email' && item.name != 'slope-internal') {
        list.push(item.name)
      }
    })

    return {
      keyword: '',
      list: list,
      name: this.$route.name,
      headerShow: true,
      checked1v1: false
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val)
        this.name = val.name
      },
      deep: true
    }
  },
  created() {
    this.getCheck1v1()
  },
  computed: {
  },
  methods: {
    getCheck1v1() {
      getAction('/simple/configuration?key=check1v1').then(response => {
        if (response.success) {
          if (response.result) {
            if (response.result.configurationValue === 'true') {
              this.checked1v1 = true
            } else {
              this.checked1v1 = false
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    header(bool) {
      this.headerShow = bool
    },
    showLogin() {
      this.$refs.header.showLoginHandle()
    },
    showLoginUp() {
      this.$refs.header.showLoginUp()
    },
    showLoginHandle() {
      this.$refs.header.showLoginHandle()
    },
    getListHandle(data) {
      this.keyword = data
    },

    getUrlVars() {
      var vars = {}
      var parts = window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (m, key, value) {
          vars[key] = value.split('#')[0]
        }
      )
      return vars
    }
  }
}
</script>

<style lang="less">
p,div,span{
  word-break: break-word;
}
:global(div.swiper-container) {
  z-index: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue